<template>
  <v-menu :close-on-content-click="false" min-width="250">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>
          mdi-dots-vertical
        </v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <px-cancelar-dialog v-if="hasRoleComprador"
                          texto-botao="Cancelar compra"
                          :titulo="getTitulo"
                          :descricao="getDescricao"
                          @cancelar-dialog="onClickCancelar"
                          :disabled="isCancelado"/>
      <v-list-item v-if="hasRoleComprador"
                   @click="goToEditCompra(compra)"
                   :disabled="isEditDisabledCancelada(compra)">
        <v-list-item-icon>
          <v-icon>mdi-pencil</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
            Editar compra
        </v-list-item-content>
      </v-list-item>
      <v-list-item
          v-if="!isRascunho && hasRoleComprador"
          :disabled="isMoedaEstrangeira"
          @click="onClickCopy"
        >
        <v-list-item-icon>
          <v-icon>mdi-content-copy</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
            Copiar compra
        </v-list-item-content>
      </v-list-item>
      <px-atualizar-moeda-dialog v-if="isMoedaEstrangeira && hasRoleComprador"
                                 :compra="compra"
                                 @change="emitChange">
        <template v-slot:activator="{ on }">
          <v-list-item v-on="on">
            <v-list-item-icon>
              <v-icon>mdi-currency-usd</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                Atualizar moeda
            </v-list-item-content>
          </v-list-item>
        </template>
      </px-atualizar-moeda-dialog>
      <v-list-item @click="gerarPdfV2(compra)" :disabled="loadingPdf">
        <v-list-item-icon>
          <v-icon>mdi-file-pdf-box</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
            Gerar PDF
            <v-progress-circular
              class="ml-3"
              :size="20"
              :width="3"
              v-if="loadingPdf"
              indeterminate
              color="primary"
            ></v-progress-circular>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="hasRoleComprador"
                   @click="reenviarEmail"
                   :disabled="loadingEmail || enviadoEmail">
        <v-list-item-icon>
          <v-icon :disabled="enviadoEmail">mdi-email-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
            Reenviar e-mail
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="hasRoleComprador"
                   @click="reenviarWhatsapp"
                   :disabled="loadingWhatsapp || enviadoWhats">
        <v-list-item-icon>
          <v-icon :disabled="enviadoWhats">mdi-whatsapp</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
            Reenviar whatsapp
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <px-confirm-dialog ref="confirm"/>
  </v-menu>
</template>

<script>
import { SituacaoCompra, TipoRelatorio } from 'px-business-components';
import moedaMixin from '@/mixins/moeda-mixin';
import AtualizarMoedaDialog from '@/modules/compra/edicao/AtualizarMoedaDialog.vue';
import RelatoriosService from '@/api/relatorios-service';
import { mapGetters } from 'vuex';
import CompraService from '@/modules/compra/compra-service';

export default {
  mixins: [moedaMixin],
  props: {
    compra: Object,
  },
  data() {
    return {
      loadingWhatsapp: false,
      loadingPdf: false,
      loadingEmail: false,
      enviadoWhats: false,
      enviadoEmail: false,
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador', 'hasRoleGestorCompras']),
    moeda() {
      return this.compra.moeda;
    },
    isEditDisabledCancelada() {
      return item => [
        SituacaoCompra.keys.CANCELADA.key,
        SituacaoCompra.keys.RECUSADA.key,
        SituacaoCompra.keys.RASCUNHO.key,
        SituacaoCompra.keys.AGUARDANDO_APROVACAO_INTERNA.key,
      ].includes(item.situacao);
    },
    isRascunho() {
      return this.compra.situacao === SituacaoCompra.keys.RASCUNHO.key;
    },
    isCancelado() {
      return this.compra.situacao === SituacaoCompra.keys.CANCELADA.key;
    },
    getTitulo() {
      return 'Cancelar compra';
    },
    getDescricao() {
      return 'A compra será cancelada e a operação não poderá ser desfeita.';
    },
  },
  methods: {
    onClickCancelar(motivoRecusa) {
      CompraService.cancelar(this.compra.id, this.buildCompra(motivoRecusa))
        .then(() => {
          this.emitChange();
          this.$toast('Compra cancelada com sucesso', { color: 'success' });
        });
    },
    buildCompra(motivoRecusa) {
      return {
        id: this.compra.id,
        motivoRecusa,
      };
    },
    reenviarWhatsapp() {
      this.loadingWhatsapp = true;
      CompraService.reenviarWhatsapp(this.compra.id)
        .then(() => {
          this.$toast('Whatsapp reenviado com sucesso!', { color: 'success' });
          this.enviadoWhats = true;
        })
        .finally(() => {
          this.loadingWhatsapp = false;
        });
    },
    reenviarEmail() {
      this.loadingEmail = true;
      CompraService.reenviarEmail(this.compra.id)
        .then(() => {
          this.$toast('Email reenviado com sucesso!', { color: 'success' });
          this.enviadoEmail = true;
        })
        .finally(() => {
          this.loadingEmail = false;
        });
    },
    goToEditCompra(item) {
      if (item.situacao === SituacaoCompra.keys.ELABORACAO.key) {
        this.$refs.confirm.open('Certifique-se de que a integração esteja finalizada antes de avançar.',
          'Antes de editar, certifique-se de que a compra em elaboração tenha finalizado o processo de integração. A edição antecipada pode causar a duplicação da compra no seu ERP.',
          { width: 450 })
          .then((confirm) => {
            if (confirm) {
              this.goToEditCompraConfirm(item);
            }
          });
      } else {
        this.goToEditCompraConfirm(item);
      }
    },
    goToEditCompraConfirm(item) {
      this.$router.push({
        name: 'main.compras.edicao',
        params: {
          id: item.id,
        },
        query: {
          isRascunho: false,
          isCopy: false,
        },
      });
    },
    gerarPdfV2(compra) {
      this.loadingPdf = true;
      const payload = {
        tipoRelatorio: TipoRelatorio.keys.ORDEM_COMPRA.key,
        arguments: {
          idCompra: compra.id,
        },
      };
      return RelatoriosService.generateReport(compra.comprador.id, payload)
        .then(({ data }) => {
          window.open(data.reportUrl);
        })
        .finally(() => {
          this.loadingPdf = false;
        });
    },
    onClickCopy() {
      this.$router.push({
        name: 'main.compras.cadastro',
        params: {
          id: this.compra.id,
        },
        query: {
          isRascunho: false,
          isCopy: true,
        },
      });
    },
    emitChange() {
      this.$emit('change');
    },
  },
  components: {
    pxAtualizarMoedaDialog: AtualizarMoedaDialog,
  },
};
</script>
